import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as complaintPositionsActions from '../../actions/ComplaintPositions';
import * as complaintPositionActions from '../../actions/ComplaintPosition';
import ComplaintPositionForm from './ComplaintPositionForm';
import  * as createXLComplaintActions from '../../actions/CreateXLComplaint';
import {openCompanyPickerModal} from '../../actions/Modal';
import { changePageToCrateComplaintPreview, changePageToCreateComplaintPosition, changePageToCreateComplaintCustomer,changePageToComplaintPreview} from '../../actions/Page';


class MenageComplaintPosition extends Component {
    
    onChange = (name, value) => {
        this.props.updateFormField(name, value);
    }
    
    onFormSubmit = (position) => {
        this.props.submitForm(position);
    }

    onCancelClick = () => {
        this.props.cancelEdit();
    }

    onChangeCheck = (event) => {
        this.onChange(event.target.name,event.target.checked);
    }

    textInputOnChange = (event) => {
        let params = Object.assign({},this.props.XLComplaint);
        params[event.target.name] = event.target.value;
        this.props.setXLComplaintParams(params);
    }

    dateChange = (name,date) => {
        this.onChange(name, date);
    }

    onBackButtonClick = () => this.props.goToCustomerPage();

    onNextButtonClick = () => {
        const id = this.props.complaintPositions.positions.length + 1;
        this.props.addComplaintPosition(this.props.complaintPosition,id);
        this.props.goToPreviewPage();
    };

    onAddPurchaseAddressButtonClick = () => this.props.openCompanyPickerModal();

    render(){
        return(
            <ComplaintPositionForm
                complaintType={this.props.complaint.complaintType}
                componentsToRender={this.props.complaintPositionsComponents}
                onFormSubmit={this.onFormSubmit}
                onCancelClick={this.onCancelClick}
                couriers={this.props.util.couriers}
                onChange={this.onChange}
                position={this.props.complaintPosition}
                quantityCorrectionsProposals={this.props.util.quantityCorrectionsProposals} 

                allowMultiplePositionsForComplaint={this.props.allowMultiplePositionsForComplaint}
                selectedCompany={this.props.selectedCompany}
                onNextButtonClick={this.onNextButtonClick}
                onBackButtonClick={this.onBackButtonClick}
                files={this.props.files}
                purchaseProve={this.props.purchaseProve}
                textInputOnChange={this.textInputOnChange}
                onChangeCheck={this.onChangeCheck}
                onAddPurchaseAddressButtonClick={this.onAddPurchaseAddressButtonClick}
                customerType={this.props.customerType}
                />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        allowMultiplePositionsForComplaint:state.util.allowMultiplePositionsForComplaint,
        customerType: state.customer.type,
        complaint: state.complaint,
        complaintPosition: state.complaintPosition,
        complaintPositions: state.complaintPositions,
        complaintPositionsComponents: state.complaintPositionsComponents.complaintPositionComponents, //TODO
        util: state.util,
        files: state.complaintPosition.files,
        purchaseProve: state.complaintPosition.purchaseProve,
        selectedCompany:state.company.selectedRow
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addComplaintPosition: (complaintPosition, id) => dispatch(complaintPositionsActions.AddComplaintPosition(complaintPosition,id)),
        goToPreviewPage: () => dispatch(changePageToCrateComplaintPreview()),
        goToCustomerPage: () => dispatch(changePageToCreateComplaintCustomer()),
        openCompanyPickerModal: () => dispatch(openCompanyPickerModal()),
        updateFormField: (name, value) => dispatch(complaintPositionActions.updateField(name, value)),
        submitForm: (complaintPosition) => dispatch(complaintPositionsActions.SaveComplaintPostion(complaintPosition)),
        cancelEdit : () =>dispatch(complaintPositionActions.DismissChanges()),
    };
};

MenageComplaintPosition.propTypes = {
    updateFormField: PropTypes.func,
    complaintPositions:PropTypes.array,
    submitForm: PropTypes.func,
    cancelEdit: PropTypes.func,
    complaint: PropTypes.object,
    complaintPositionsComponents: PropTypes.object,
    util: PropTypes.object,
    complaintPosition: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(MenageComplaintPosition);


// WEBPACK FOOTER //
// ./src/components/MenageComplaintPosition/MenageComplaintPosition.js